import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import '../../content/css/UploadDocument.css';

export default class UploadDocument extends Component {
    constructor(props) {
        super(props);
    }


    getFile = () => {
        if (this.props.file === null) return;

        return (
            <li key={this.props.file.name}>
                {this.props.file.name} - {this.props.file.size} bytes
            </li>
        );
    }

    handleDrop = (files) => {
        this.props.onUpload(files);
    }

    render() {
        return (
            <div className="upload-document">
                <Dropzone onDrop={this.handleDrop}>
                    {({ getRootProps, getInputProps }) => (
                        <section className="container">
                            <div {...getRootProps({ className: 'dropzone' })}>
                                <input {...getInputProps()} />
                                <p>Drag and drop your contract here or click to browse for files on your device</p>
                                <em>(PDF and Word documents will be accepted)</em>
                            </div>
                        </section>
                    )}
                </Dropzone>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Upload/UploadDocument.js